import { Component, AfterViewInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, RoutesRecognized, RouterEvent } from '@angular/router';
import { DataService } from './services/data.service';
import { Base } from './classes/base';


@Component({
  selector: 'boot-root',
  templateUrl: './boot.component.html'
})
export class BootComponent extends Base {

  pageScrolls: IPageScroll[] = [];
  container: Element = document.getElementsByClassName("content-wrap")[0];

  constructor(private router: Router, private data: DataService) {
    super();
    this.addAppPageClass = false;
    this.resetLoading();
    router.events
      .subscribe((event: RouterEvent) => {
        if (event instanceof NavigationStart) {
          document.body.classList.remove('navigation-state-end');
          document.body.classList.remove('error-state-active');
          document.body.classList.remove('error-deny-restart');
          document.body.classList.add('navigation-state-start');
        }
        else if (event instanceof NavigationEnd) {
          setTimeout(() => {
            document.body.classList.remove('navigation-state-start');
            document.body.classList.add('navigation-state-end');
          });
        }

      });

  }

  ngAfterViewInit() {
    this.container = document.getElementsByClassName("content-wrap")[0];
  }


  doLogOff() {
    this.isLoading = true;
    this.data.logOff();
  }

  get tokenInfo() {
    return this.data.getTokenInfo();
  }

  getShortUrl(url: string) {
    var qStringIndex = url.indexOf("?");
    var shortUrl = qStringIndex !== -1 ? url.substr(0, qStringIndex) : url;

    return shortUrl;
  }

}

interface IPageScroll {
  position: number;
  pageUrl: string;
}
